(function() {
	'use strict';

	angular.module('snap').config(config);

	function config($stateProvider) {
		$stateProvider.state('snap', {
			url : '/snap',
			views : {
				'snapView' : {
					templateUrl : 'snap/views/snap.tpl.html',
					controller : 'SnapCtrl',
					controllerAs : 'snap'
				}
			}
		});
	}
}());
